import React, { useState } from 'react';
import {
    Container,
    Typography,
    Paper,
    Box,
    TextField,
    Button,
    Alert,
    CircularProgress,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormControlLabel,
    Switch
} from '@mui/material';
import { adminInstance } from '../../../utils/axios';
import { useNavigate } from 'react-router-dom';

const CreateExam = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        title: '',
        category: '',
        description: '',
        isActive: false,
        numberOfQuestions: 0,
        monthlySubscriptionFee: 0
    });

    const handleChange = (e) => {
        const { name, value, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: e.target.type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            await adminInstance.post('/api/admin/exams', formData);
            navigate('/admin/exams');
        } catch (err) {
            setError(err.response?.data?.message || 'Error creating exam');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container>
            <Typography variant="h4" component="h1" gutterBottom sx={{ mt: 4, mb: 3 }}>
                Create New Exam
            </Typography>

            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            <Paper sx={{ p: 4 }}>
                <form onSubmit={handleSubmit}>
                    <Typography variant="h6" sx={{ mb: 3 }}>
                        Exam Information
                    </Typography>
                    
                    <Box sx={{ mb: 3, display: 'block' }}>
                        <TextField
                            fullWidth
                            label="Exam Title"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            required
                        />
                    </Box>

                    <Box sx={{ mb: 3, display: 'block' }}>
                        <FormControl fullWidth>
                            <InputLabel>Category</InputLabel>
                            <Select
                                name="category"
                                value={formData.category}
                                onChange={handleChange}
                                label="Category"
                                required
                            >
                                <MenuItem value="medical">Medical</MenuItem>
                                <MenuItem value="nursing">Nursing</MenuItem>
                                <MenuItem value="pharmacy">Pharmacy</MenuItem>
                                <MenuItem value="other">Other</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <Box sx={{ mb: 3, display: 'block' }}>
                        <TextField
                            fullWidth
                            label="Description"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            multiline
                            rows={4}
                        />
                    </Box>

                    <Box sx={{ mb: 3, display: 'block' }}>
                        <TextField
                            fullWidth
                            label="Number of Questions"
                            name="numberOfQuestions"
                            type="number"
                            value={formData.numberOfQuestions}
                            onChange={handleChange}
                            required
                        />
                    </Box>

                    <Box sx={{ mb: 3, display: 'block' }}>
                        <TextField
                            fullWidth
                            label="Monthly Subscription Fee (£)"
                            name="monthlySubscriptionFee"
                            type="number"
                            value={formData.monthlySubscriptionFee}
                            onChange={handleChange}
                            required
                        />
                    </Box>

                    <Box sx={{ mb: 3, display: 'block' }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.isActive}
                                    onChange={handleChange}
                                    name="isActive"
                                />
                            }
                            label="Publish Exam"
                        />
                    </Box>

                    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => navigate('/admin/exams')}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            size="large"
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={24} /> : 'Create Exam'}
                        </Button>
                    </Box>
                </form>
            </Paper>
        </Container>
    );
};

export default CreateExam; 